import { Injectable } from '@angular/core';
import { CompetitionData, LoginService, TestData } from './login.service';
import { format } from 'date-fns';


@Injectable({
  providedIn: 'root'
})

export class Questions {
  public id = '';
  public question = '';
  public answers = '';
  public correctAnswer = '';
  public imageUrl = '';
  public imageUrlLarge = '';
  public points = -1;
  public questionType = -1;
}
export class AnswersMap {
  public pointsValued = 0;
  public answersProvided = '';
}

export class ExamService {
  public loadedQuestions = [];
  public testdata: TestData;
  public competitiondata: CompetitionData;
  public isCompetition = false;
  public label = '';
  public sessionResultData;
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  public savedSessionResult = <AnswersMap[]>([]);
  private loginService: LoginService;
  constructor() { }

  public async grabTest(path, service: LoginService) {
    this.loginService = service;
    await this.loginService.grabdata(path).then((data: any) => {
      this.parseQuestions(data.data.q);
    });
  }
  public parseQuestions(questions) {
    this.loadedQuestions = [];
    for (const quest in questions) {
      if (Object.prototype.hasOwnProperty.call(questions, quest)) {
        const question: Questions = {
          answers: questions[quest].answers, correctAnswer: questions[quest].rightAnswer, id: quest, imageUrl: '',
          imageUrlLarge: './../assets/qpath.png', points: questions[quest].points, question: questions[quest].question,
          questionType: questions[quest].questionType
        };
        this.loadedQuestions.push(question);
      }
    }
    this.loginService.startTest();
  }
  public saveTestResult(testResultVal, answersProvidedVal) {
    const currentTimeVal = format(new Date(), 'yyyy-MM-dd h:mm a');
    let testAttempt = 0;
    if (this.loginService.studentResults &&
      this.loginService.studentResults[this.testdata.teacherpath] &&
      this.loginService.studentResults[this.testdata.teacherpath][this.loginService.datalanguages[this.testdata.langid].shortval] &&
      this.loginService.studentResults[this.testdata.teacherpath]
      [this.loginService.datalanguages[this.testdata.langid].shortval][this.testdata.class] &&
      this.loginService.studentResults[this.testdata.teacherpath]
      [this.loginService.datalanguages[this.testdata.langid].shortval][this.testdata.class][this.testdata.testid]
    ) {
      testAttempt = this.loginService.studentResults[this.testdata.teacherpath]
      [this.loginService.datalanguages[this.testdata.langid].shortval][this.testdata.class][this.testdata.testid].length;
    }

    let result = '';
    for (const answer in answersProvidedVal) {
      if (Object.prototype.hasOwnProperty.call(answersProvidedVal, answer)) {
        result += answer + ':' + answersProvidedVal[answer].answersProvided + ':' + answersProvidedVal[answer].pointsValued + '_';
      }
    }

    const vals = { currentTime: currentTimeVal, testResult: testResultVal, answersProvided: result };
    const path = 'users/' + this.loginService.userAccount.uid + '/kids/' + this.loginService.userAccount.lastUsedMember + '/testresults/' +
      this.testdata.teacherpath + '/' + this.loginService.datalanguages[this.testdata.langid].shortval + '/' +
      this.testdata.class + '/' + this.testdata.testid + '/' + testAttempt;
    this.loginService.updatedata(path, vals).then(()=>{
      this.loginService.grabStudentResults();
    });

    //this.loginService.studentResults
  }
  public setSessionResultData(testdata) {
    this.sessionResultData = testdata;
    this.savedSessionResult = [];
    if (this.sessionResultData === null) {
      return;
    }
    const answersProvided = this.sessionResultData.answersProvided.split('_');
    for (const answer in answersProvided) {
      if (Object.prototype.hasOwnProperty.call(answersProvided, answer)) {
        if (answersProvided[answer] !== '') {
          const values = answersProvided[answer].split(':');
          this.savedSessionResult.push({ pointsValued: values[2], answersProvided: values[1] });
        }
      }
    }
  }
}
